import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import BorrowingStatus from '../../shared/BorrowingStatus';
import SidebarCompactTitle from '../../sidebar/SidebarCompactTitle';
import DollarAmount from '../../shared/DollarAmount';

export default class FinesStatus extends BcReactComponent {

  renderFineAmount() {
    const { totalFines } = this.props;
    return (
      <span className="fine-amount">
        <DollarAmount amount={totalFines} />
      </span>
    );
  }

  render() {
    return (
      <BorrowingStatus currentSection={this.props.currentSection} to="/v2/fines">
        <SidebarCompactTitle
          title={<FormattedMessage id="section_title_fines" />}
          count={this.renderFineAmount()}
          selected={this.props.currentSection} />
      </BorrowingStatus>
    );
  }
}

FinesStatus.propTypes = {
  currentSection: PropTypes.bool,
  totalFines: PropTypes.number
};



// WEBPACK FOOTER //
// ./app/components/borrowing/fines/FinesStatus/FinesStatus.jsx